import debounced from './lib/debounced';

export default debounced;
